import {CommonModule} from '@angular/common';
import {Component, HostListener} from '@angular/core';
import {IStackPanelView, StackPanelService} from './stack-panel.service';

const BASE_LAYER_Z_INDEX = 1050;

@Component({
  selector: 'app-stack-panel-host',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stack-panel-host.component.html',
  styleUrls: ['./stack-panel-host.component.scss']
})
export class StackPanelHostComponent {
  readonly panels$ = this.stackPanelService.panels$;

  constructor(private stackPanelService: StackPanelService) {
  }

  trackByPanelId(_index: number, panel: IStackPanelView): string | number {
    return panel.id;
  }

  getLayerZIndex(index: number): number {
    return BASE_LAYER_Z_INDEX + index;
  }

  onBackdropClick(panel: IStackPanelView): void {
    if (!panel.config.ignoreBackdropClick) {
      panel.ref.hide();
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent): void {
    const panels = this.stackPanelService.getPanels();
    if (!panels.length) {
      return;
    }

    const activePanel = panels[panels.length - 1];
    if (activePanel.config.keyboard === false) {
      return;
    }

    event.preventDefault();
    activePanel.ref.hide();
  }
}
